import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { api } from "../../common/setupApi";
import { selectSelectedEvent } from "../events/eventsSlice";

export const getFiles = createAsyncThunk(
  "files/get",
  async (_, { getState, rejectWithValue }) => {
    const eventId = selectSelectedEvent(getState()).id;
    return api
      .get(`files/?session=${eventId}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return rejectWithValue(err.response?.data);
      });
  },
  {
    condition: (params, { getState }) => {
      if (params?.ignoreCondition) {
        return true;
      }
      // https://redux-toolkit.js.org/api/createAsyncThunk#canceling-before-execution
      const { status } = selectFiles(getState());
      if (status === "pending") {
        // Already fetched or in progress, don't need to re-fetch
        return false;
      }
    },
  }
);

const initialState = {
  status: "idle",
  data: [],
  error: null,
  open: false,
};

const filesSlice = createSlice({
  name: "files",
  initialState,
  reducers: {
    add: (state, action) => {
      state.data.push(action.payload);
    },
    remove: (state, action) => {
      state.data = state.data.filter((d) => d.id !== action.payload);
    },
    open: (state) => {
      state.open = true;
    },
    close: (state) => {
      state.open = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFiles.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(getFiles.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.data = action.payload;
      })
      .addCase(getFiles.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase("auth/logout", () => initialState);
  },
});

export const filesActions = filesSlice.actions;

const _selectFiles = (state) => state.files;

export const selectFiles = createSelector(
  [(state) => _selectFiles(state)],
  (files) => {
    const data = files.data;
    const status = files.status;
    const error = files.error;
    const isLoading = status === "pending";
    return { data, status, error, isLoading };
  }
);

export const selectFilesOpenDrawer = (state) => state.files.open;

export default filesSlice.reducer;
